export async function getMatches(token) {
  const res = await fetch("https://marsiweb.com/padelapi/api/matches", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return await res.json();
}
